<template>
  <div class="share-brief">
    <div class="close-btn">
      <button
        type="button"
        class="circled interactive grey close-modal outline"
        @click.stop.prevent="closeShare"
      >
        <svg-icon id="cross"></svg-icon>
      </button>
    </div>

    <div class="share-brief-heading">
      Download {{ data.brief.campaign_title }}
    </div>

    <div class="share-pdf-container">
      <loader-button
        @click.native="downloadPdf"
        label="Download PDF"
        class="download"
        :loading="loading"
        after-icon="download"
      ></loader-button>
    </div>
  </div>
</template>

<script>
import BaseModal from '../Base'
import fileDownload from 'js-file-download';

export default {
  extends: BaseModal,
  props: {
    data: {
      type: Object,
      required: true,
    }
  },
  data () {
    return {
      shareLink: null,
      loading: false
    }
  },
  methods: {
    closeShare() {
      this.$emit('cancel');
    },
    downloadPdf() {
      this.loading = true;
      axios
        .get(`/api/account/briefs/${this.data.brief.id}/export`, {
          responseType: "blob",
        })
        .then((response) => {
          this.loading = false;
          fileDownload(response.data, `${this.data.brief.campaign_title}.pdf`);
        });
    }
  },
}
</script>
